import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractShapeComponent } from '../abstract-shape.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3Hair]',
  templateUrl: './hair.component.html',
  styleUrls: ['./hair.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HairComponent extends AbstractShapeComponent {}
